module.exports = { //例子 this.$i18n.t('main.submit_audit')  {{$t('main.status_name')}}

    main: {
        'text1': '查看资料',
        'text2': '更改密码',
        'text3': '提交文件',
        'text4': '登出',
        'text5': '登出确认',
        'text6': '您确定退出首页吗？',
        'text7': '取消',
        'text8': '退出',
        'text9': '谢谢！',
        'text10': '我们的客户经理将在 3 个工作日内与您联系。',
        'text11': '好的',
        'text12': '首页',
        'text13': '我的交易',
        'text14': '数字存款',
        'text15': '数字提款与付费',
        'text16': '法定货币存款',
        'text17': '法定货币提款',
        'text18': '场外交易',
        'text19': '外汇',
        'text20': '了解客户',
        'text21': '公司声明书',
        'text22': '公司信息',
        'text23': '拥有权/控制人/股东信息',
        'text24': '交易授权书',
        'text25': '区块链',
        'text26': '法定货币',
        'text27': '产品',
        'text28': '即将推出',
        'text29': '我们即将推出。请稍后再来。',
        'text30': '未有帐户？',
        'text31': '注册',
        'text32': '我们会尽快以电邮向您发送重置密码链接。',
        'text33': '忘记密码？',
        'text34': '请输入您用于注册的电子邮件。',
        'text35': '电子邮件',
        'text36': '提交',
        'text37': '已经有帐户？',
        'text38': '登录',
        'text39': '请输入您的电子邮箱',
        'text40': 'USDT 余额',
        'text41': 'USDC 余额',
        'text42': 'USD 余额',
        'text43': 'SGD 余额',
        'text44': 'ETH 余额',
        'text44_1': 'ETH',
        'text45': 'BTC 余额',
        'text46': '欢迎加入！',
        'text47': '欢迎！感谢您选择新技银行！您现在可以访问首页。要完全启用我们的理财服务，请点击下面的链接提交相关文件。',
        'text48': '预约客户经理',
        'text49': '如果您在提交文件方面需要任何协助，请点击下面的按钮，我们将在 3 个工作日内与您联系。',
        'text50': '自己完善所有的设置',
        'text51': '文件提交',
        'text52': '我有部分或全部所需文件，我想继续提交。 （请注意，您将能够逐步保存提交的文件）。',
        'text53': '继续',
        'text54': '所需文件清单',
        'text55': '公司注册证书/ACRA',
        'text56': '所有董事的身份证明',
        'text57': '所有权/控制结构',
        'text58': '所有股东和控制人的身份证明',
        'text58_y': '（身份证或护照，经公证人、公司秘书或注册会计师正式认证，并附有会员编号）',
        'text59': '授权人员身份证明',
        'text60': '组织章程大纲及章程细则',
        'text61': '签发后 3 个月内的公司地址证明',
        'text61_y': '（自提交日 3 个月内发出的水电费账单或银行对账单）',
        'text62': '任何相关许可证',
        'text63': '母公司文件（如适用）',
        'text64': '显示较少',
        'text65': '稍后处理',
        'text66': '请在提交前完成所有部分。',
        'text67': '现在提交',
        'text68': '已完成',
        'text69': '未完成',
        'text69_y': '企业声明',
        'text70': '本节要求提交公司董事和股东的身份证明文件',
        'text71': '编辑',
        'text72': '请确保您在提交之前已完成所有部分。',
        'text73': '金融机构信息不完整',
        'text74': '公司资料不完整',
        'text75': '所有权/控制人/股东信息不完整',
        'text76': '交易授权表信息不完整',
        'text77': '我们已收到您的提交',
        'text78': '感谢您提交！我们将对其进行审核并尽快回复。',
        'text79': '已保存',
        'text80': '您现在提交 KYC 吗？',
        'text81': '您已完成所有部分！',
        'text82': '请确保您已填写以下所有字段。',
        'text83': '全名',
        'text84': '身份证/护照号码',
        'text85': '职称',
        'text86': '联系电话',
        'text87': '身份证/护照',
        'text87_y': '身份证正面和背面（如果是新加坡人）/护照（如果是外国人）',
        'text88': '将文件拖放到此处',
        'text89': '选择文件',
        'text90': '*最多10个文件',
        'text91': '添加成员',
        'text92': '*最多3名成员',
        'text93': '声明',
        'text94': '通过以下提交，客户确认使用 新技银行 服务的目的是合法的，有关、经手或办理的资金不是多米尼加或任何其他司法管辖区的税务罪行所得。',
        'text95': '客户了解新技银行 将依赖所提供的陈述和信息的准确性和完整性。客户特此证实所提供的信息和数据是真实、完整和正确的。若有更改将及时通知 新技银行',
        'text96': '董事确认',
        'text97': '董事姓名',
        'text98': '指定董事',
        'text99': '日期',
        'text100': '显示此标签的描述',
        'text101': '年/月/日',
        'text102': '董事签名',
        'text103': '使用鼠标或触控板在方框内签名',
        'text104': '保存',
        'text105': '签名',
        'text106': '最多加 3',
        'text107': '数据不能为空',
        'text108': '保存成功',
        'text109': '提交前请签名',
        'text110': '请确保您的选项是正确的',
        'text111': '您是否是金融机构吗？',
        'text112': '是',
        'text113': '否',
        'text114': 'BETH 公司的 AML/CFT 问卷',
        'text115': '最新签署的 AML/CFT 政策',
        'text116': '最新签署的企业范围风险评估',
        'text117': '组织章程大纲及章程细则',
        'text118': '公司注册证书 (COI)：',
        'text118_y': '1. ACRA 如果在新加坡注册；',
        'text118_y2': '2.如果公司是在海外注册，请在提交后的3个月内提供经认证的公司注册证书英文翻译副本。',
        'text119': '（如果在新加坡注册） - 日期在 3 个月内或海外等效英文',
        'text120': '所有董事的身份证明',
        'text121': '（身份证或护照，经公证人、公司秘书或注册会计师正式认证，并附会员编号）',
        'text122': '所有最终实益拥有人的身份证明',
        'text123': '母公司文件（如适用）',
        'text124': '（地址与身份证明-三个月有效期的水电费账单或银行账单）',
        'text125': '（如果在新加坡注册） - 日期在 3 个月内或海外同等英语',
        'text126': '交易目的',
        'text127': '（付款发票等文件）',
        'text128': '请确认公司声明以便继续。',
        'text129': '重要提示：到目前为止，本节中上传的所有文档都不会被保存。',
        'text130': '确认',
        'text131': '股东姓名',
        'text132': '所有权百分比',
        'text133': '护照号码',
        'text134': '发行国',
        'text135': '- 请选择 -',
        'text136': '添加其他股东',
        'text137': '*最多5名成员',
        'text138': '主要管理人员和董事信息',
        'text139': '位置',
        'text140': '添加其他管理人员',
        'text141': '最多添加 5 个',
        'text142': '公司名称',
        'text143': '注册地址',
        'text144': '国家',
        'text145': '邮寄地址',
        'text146': '电话号码',
        'text147': '公司网站',
        'text148': '注册号码',
        'text149': '注册国家',
        'text150': '注册日期',
        'text151': '业务性质',
        'text152': '实体类型',
        'text153': '独资企业',
        'text154': '有限合伙制',
        'text155': '有限责任公司',
        'text156': '公司',
        'text157': '其他',
        'text158': '开展业务的国家',
        'text159': '员工人数',
        'text160': '大约客户数目',
        'text161': '您的客户所在的前 5 个国家',
        'text162': '年营业额（美元）',
        'text163': '（我们可能会要求您提供相关文件）',
        'text164': '财富来源',
        'text165': '交易最频繁的前 3 种货币',
        'text166': '月度预期交易量',
        'text167': '<$10,000 美元',
        'text168': '10,000 美元 - 100,000 美元',
        'text169': '100,000 美元 - 500,000 美元',
        'text170': '500,000 美元 - 1,000,000 美元',
        'text171': '1,000,000 美元 - 10,000,000 美元',
        'text172': '>10,000,000 美元',
        'text173': '预计每月交易频率',
        'text174': '临时交易要求',
        'text175': '少于 10 笔交易',
        'text176': '10 到 20 笔交易之间',
        'text177': '超过 20 笔交易',
        'text178': '运营年数',
        'text179': '欢迎回来',
        'text180': '我们的使命-理财业务简单，快速，可靠',
        'text181': '未有账户？',
        'text182': '谢谢你的注册！你的账户已成功创建。请立即登录以便完善账号的实名认证以及上传相关的公司资料。',
        'text183': '密码已更新成功，请使用新密码登录。',
        'text184': '欢迎来到',
        'text185': '电子邮件',
        'text186': '密码',
        'text187': '忘记密码？',
        'text188': '忘记密码',
        'text189': '当然',
        'text190': '验证码',
        'text191': '邮箱不能为空',
        'text192': '密码不能为空',
        'text193': '必须填写验证码',
        'text194': '验证码不正确',
        'text195': '登陆成功',
        'text196': '创建帐户',
        'text197': '电子邮件验证码',
        'text198': '请求验证码',
        'text199': '手机号码',
        'text200': '国家代码',
        'text201': '确认密码',
        'text202': '特邀代码（可选）',
        'text203': '请输入全名',
        'text204': '请输入您的电子邮件',
        'text205': '请填写电子邮箱验证码',
        'text206': '请填写您的电话号码',
        'text207': '请填写密码',
        'text208': '请填写确认密码',
        'text209': '两个密码不匹配，请重新输入',
        'text210': '注册成功',
        'text211': '重置你的密码',
        'text212': '请输入您的新密码。',
        'text213': '新密码',
        'text214': '确认新密码',
        'text215': '修改成功',
        'text216': '首页登录-需提交相关文件',
        'text217': '公司简介证书（SSM/SSL）',
        'text218': '股东',
        'text219': '身份证/护照',
        'text220': '全名',
        'text221': '最多添加 3 名股东',
        'text222': '请填写姓名',
        'text223': '必须上传公司资料',
        'text224': '必须添加股东信息',
        'text225': '上传成功',
        'text226': '随时更新您的密码。',
        'text227': '填写您的个​​人资料以使用所有功能。',
        'text228': '我们将对其进行审核并尽快回复您。',
        'text229': '待审核',
        'text230': '提交失败。我们将尽快与您联系。',
        'text231': '拒绝',
        'text232': '立即完成',
        'text233': '按此键-预约客户经理协办开户',
        'text234': '编辑个人资料',
        'text235': '*文件大小最大5MB',
        'text236': '更新',
        'text237': '当前密码',
        'text238': '请填写新密码',
        'text239': '文件大小不能超过 5M',
        'text240': '文件类型错误',
        'text241': '公司简介',
        'text242': '请选择日期',
        'text243': '在这里下载',
        'text244': '验证码已发送到您上面的电子邮箱，请输入验证码',
        'text245': '密码至少为 8 个字符，并且至少包含大写、小写和 1 个数字',
        'text246': '密码只能为大写字母+小写字母+数字的8至12位字符组合',
        'text247': '母公司文件（如适用）',
        'text248': '您已经超过15分钟未操作，请重新登陆',
        'text249': '全部显示',
        'text250': '电子邮件地址',
        'text251': '我的账户',
        'text252': '帐户名称',
        'text253': '帐户号码',
        'text254': '参考',
        'text255': '余额',
        'text256': '此部分要求上传公司支持文件，例如董事和股东身份证明等。',
        'text257': '会话即将到期',
        'text258': '您希望现在继续您的会话或退出?',
        'text259': '现在退出',
        'text260': '保持登录',
        'text261': '*最多10个文件jpeg, pdf, png，最大10MB',
        'text262': '你正在离开这个页面。所有上传的文件将不会被保存',
        'text263': '保存并继续',
        'text264': '拒绝访问',
        'text265': '很抱歉，在您的KYC获得批准之前，您无法访问该功能。你可以在个人主页上查看你的KYC状态',
        'text266': '好的',
        'text267': '私人银行产品',
        'text268': '结构化产品',
        'text269': '投资理财',
        'text270': '交易历史',
        'text271': '新的法定存款',
        'text272': '点击查看我的银行详细信息按钮查看银行详细信息。 请注意，最低存款额为 1,000 美元或等值。',
        'text273': '我们的银行详细信息',
        'text274': '请确保包含参考资料',
        'text275': '当您向银行提供姓名或首字母缩写以转账至BETH账户时。该参考是一个唯一标识符，使我们能够识别到您的BETH账户的传入转账。',
        'text276': '收款行',
        'text277': '银行地址',
        'text278': '银行所在国家',
        'text279': '银行国际代码（SWIFT Code）',
        'text280': '银行账号',
        'text281': '代理银行国际代码（SWIFT Code）',
        'text282': '美元账户号码',
        'text283': '货币种类',
        'text284': '公司地址',
        'text285': '复制银行详细信息',
        'text286': '数字资产存款',
        'text287': '复制或扫描以下的二维码以便存入您的数字资产钱包。',
        'text288': 'USDT 余额 (ERC20 BEP20)',
        'text288_1': 'USDT 余额',
        'text288_3': 'USDT',
        'text288_2': '(ERC20 BEP20)',
        'text289': '美元近似值',
        'text290': '地址',
        'text291': '复制',
        'text292': 'USDC 余额 (ERC20 BEP20)',
        'text292_1': 'USDC 余额',
        'text292_3': 'USDC',
        'text292_2': '(ERC20 BEP20)',
        'text293': 'BTC 余额',
        'text293_1': 'BTC',
        'text294': 'ETH',
        'text295': 'USDT (TRC20) 余额',
        'text296': 'USDC (TRC20) 余额',
        'text297': '复制成功',
        'text298': '银行名称：',
        'text299': '银行地址 ： ',
        'text300': '银行代码 ： ',
        'text301': '支行名称 ： ',
        'text302': '银行帐号 ： ',
        'text303': '银行账户名称：',
        'text304': '国家 ： ',
        'text305': '货币 ： ',
        'text306': 'SWIFT 地址/代码：',
        'text307': '公司地址 ： ',
        'text308': '参考 ： ',
        'text309': '交易明细',
        'text310': '交易日期',
        'text311': '交易哈希',
        'text312': '交易ID',
        'text313': '细节',
        'text314': '数量',
        'text315': '发件人地址',
        'text316': '管理员审核',
        'text317': '成功',
        'text318': '待批准',
        'text319': '被拒绝',
        'text320': '处理中的交易',
        'text321': '交易失败',
        'text322': '筛选',
        'text323': '日期范围',
        'text324': '开始日期',
        'text325': '结束日期',
        'text326': 'TXID',
        'text327': '交易类型',
        'text328': '全部',
        'text329': '重置',
        'text330': '搜索',
        'text331': '',
        'text332': '白名单里的数字资产交易',
        'text333': '导出',
        'text334': '货币类型',
        'text335': '目前没有数据可供下载。',
        'text336': '法币交易历史',
        'text337': '数字资产交易历史',
        'text338': '转账和付款详情',
        'text339': '提款金额',
        'text340': '收款账户详细信息',
        'text341': '姓名',
        'text342': '钱包地址',
        'text343': '网络类型',
        'text344': '全部',
        'text346': '账号明细',
        'text347': '转账金额',
        'text348': '收款方姓名',
        'text349': '转账和付款详情',
        'text350': '收款账户获取',
        'text351': '银行明细',
        'text352': '收款方银行名字',
        'text353': 'SWIFT代码',
        'text354': '中介银行详细信息（可选）',
        'text355': '中介银行名称',
        'text356': '中介银行国家',
        'text357': '中介银行 Swift 代码',
        'text358': '中介银行地址',
        'text359': '其他详情',
        'text360': '交易目的',
        'text361': '添加新地址',
        'text362': '我的地址',
        'text363': '删除',
        'text364': '没有数据',
        'text365': '收款账户详细信息',
        'text366': '钱包地址',
        'text367': '删除确认',
        'text368': '您确定要从您的列表中删除此地址吗？',
        'text369': '消除',
        'text370': '管理我的地址',
        'text371': '请填写姓名',
        'text372': '请填写地址',
        'text373': '请选择类型',
        'text374': '添加成功',
        'text375': '编辑成功',
        'text376': '成功删除',
        'text377': '添加新收款人',
        'text378': '我的收款人',
        'text379': '您确定要从您的列表中删除此收款账户吗？',
        'text380': '收款人',
        'text381': '请填写银行账号',
        'text382': '请填写受益人姓名',
        'text383': '请填写银行代码',
        'text384': '请填写银行地址',
        'text385': '请填写中间行名称',
        'text386': '请选择中间行所在国家',
        'text387': '请填写中间行代码',
        'text388': '请填写中间行地址',
        'text389': '输入金额',
        'text390': '查看详细信息',
        'text391': '选择收款人',
        'text392': '添加新的钱包地址',
        'text393': '另存为最喜欢的收款人',
        'text394': '继续',
        'text395': '保存',
        'text396': '新转账与支付（数字资产）',
        'text397': '请在提交前确保以下所有详细信息均正确无误。',
        'text398': '转账和付款详情',
        'text399': '输入一次性密码',
        'text400': '确认并继续',
        'text401': '我们收到了您的请求！',
        'text402': '您的提款请求将在 3 个工作日内得到处理。',
        'text403': '请填写验证码',
        'text404': '最喜欢的收款人',
        'text405': '其他详情',
        'text406': '电子邮件地址（可选）',
        'text407': '业务费用',
        'text408': '收款支付',
        'text409': '现金支付',
        'text410': '采购销售货物',
        'text411': '分期租购协议',
        'text412': '公司内部付款',
        'text413': '发票支付',
        'text414': '供应商付款',
        'text415': '贸易服务',
        'text416': '国库支付',
        'text417': '慈善支付',
        'text418': '教育',
        'text419': '学习',
        'text420': '外籍劳工税',
        'text421': '政府保险',
        'text422': '保险费',
        'text423': '投资与证券',
        'text424': '贷款',
        'text425': '股息',
        'text426': '兴趣',
        'text427': '其他',
        'text428': '回扣',
        'text429': '退款',
        'text430': '持有',
        'text431': '有线电视账单',
        'text432': '信用卡支付',
        'text433': '停车场收费',
        'text434': '借记卡支付',
        'text435': '牙科服务',
        'text436': '支付费用和收费',
        'text437': '医院护理',
        'text438': '医疗服务',
        'text439': '电话单',
        'text440': '租',
        'text441': '市议会服务费',
        'text442': '路費',
        'text443': '公用事业',
        'text444': '奖金支付',
        'text445': '委员会',
        'text446': '工资支付',
        'text447': '商品和服务税',
        'text448': '净所得税',
        'text449': '财产税',
        'text450': '路税',
        'text451': '纳税',
        'text452': '新转账和付款（法定货币）',
        'text453': '请填写正确的邮箱',
        'text454': '请选择交易目的',
        'text455': '转账/支付到其他账户',
        'text456': '钱可能需要最多 3 个工作日才能到达收款人手中',
        'text457': '转移到其他货币',
        'text458': '你发送',
        'text459': '可用余额',
        'text460': '收款人获取',
        'text461': '费率将每 5 分钟更新一次，金额会更新一次',
        'text462': '转移/支付到其他地址',
        'text463': '请确保您在提交之前输入了正确的详细信息。',
        'text464': '转账/付款金额',
        'text465': '刷新页面',
        'text466': '费率和金额每 5 分钟更新一次。 如果您希望继续您的交易/付款，请单击确定。',
        'text467': '刷新',
        'text468': '提款金额为0不能提款',
        'text469': '请输入提款金额',
        'text470': '要提取的数额少于最低提取数额要求。 要提取的最数额是',
        'text471': '提款超过您的最大金额',
        'text472': '存款参考是一个特殊标识符，使我们能够识别转入的数额应转入到您的 BETH 账户。 请确保您填写存款参考 ',
        'text473': '向银行提供您的姓名或姓名缩写以将其转入 BETH 帐户时。',
        'text474': '存款参考',
        'text475': '人民币余额',
        'text476': '英镑余额',
        'text477': '澳元平衡',
        'text478': '港币结余',
        'text479': '交易类型',
        'text480': '订金',
        'text481': '转账和付款',
        'text482': '转移到法定货币',
        'text483': '请选择一种货币',
        'text484': '(TRC20)',
        'text485': '我们很抱歉您还不能使用这个功能。',
        'text486': '当您的个人资料获得批准后，您将可以使用此功能。',
        'text487': '您可以在个人资料页面上查看个人资料状态。',
        'text488': '请确保在下方输入与网络类型匹配的正确钱包地址。 从另一个网络输入任何其他钱包地址将导致您的资金损失。',
        'text489': '拒绝理由',
        'text490': '*最多1个文件（JPEG 或 PNG）',
        'text491': '新技银行联名卡',
        'text492': '公司旗下的合伙人或员工都有资格申请',
        'text493': '申请',
        'text494': 'BETH联名卡',
        'text495': '敬请期待',
        'text496': '敬请期待',
        'text497': '申请对象',
        'text498': '董事',
        'text499': '合伙人',
        'text500': '选着申请对象',
        'text501': '联名卡的收费',
        'text502': '担保签证 (美金)',
        'text503': '年费',
        'text504': '联名卡的收费',
        'text505': '休止状态收费',
        'text506': '激活联名卡',
        'text507': 'POS/网上消费',
        'text508': '提款机提款',
        'text509': '提款机查询余额',
        'text510': '联名卡充值',
        'text511': '申请联名卡',
        'text512': '联名卡',
        'text513': '请确保提交的资料是准确',
        'text514': '联名卡的资料',
        'text515': '联名卡分类',
        'text516': 'VISA联名卡',
        'text517': '申请资料',
        'text518': '称谓',
        'text519': '名字',
        'text520': '姓氏',
        'text521': '新技优先网上银行登录昵称',
        'text522': '出生日期',
        'text523': '联名卡显示的名字',
        'text524': '现居的国家',
        'text525': '省/州属',
        'text526': '城市',
        'text527': '邮区号',
        'text528': '实名认证资料',
        'text529': '身份证/护照',
        'text530': '签发日期',
        'text531': '有效期至',
        'text532': '正面身份证/护照首页',
        'text533': '反面身份证/护照首页',
        'text534': '地址证明',
        'text535': '发放地址证明的政府机构',
        'text536': '地址证明的发放日期',
        'text537': '您的联名卡申请已提交。',
        'text538': '系统将会通过邮件通知您的联名卡审批结果。',
        'text539': '请把申请资料填上',
        'text540': '男士',
        'text541': '女士',
        'text542': '女士',
        'text543': '地址证明（近三个月以内银行账单，水电费账单）',
        'text544': '',
        'text545': '近三个月的账单（不可超过90天）',
        'text546': '请选择称谓',
        'text547': '请填写名字',
        'text548': '请填写姓氏',
        'text549': '请填写昵称',
        'text550': '请填写邮件',
        'text551': '请填写行动电话号码',
        'text552': '请选择出生日期',
        'text553': '请填写联名卡显示的名字',
        'text554': '请填写地址',
        'text555': '请选择现居的国家',
        'text556': '请填写省/州属',
        'text557': '请填写城市',
        'text558': '请填写邮区号',
        'text559': '请填写身份证/护照',
        'text560': '请选择签发日期',
        'text561': '请选择有效期至',
        'text562': '请上传正面身份证/护照首页',
        'text563': '请上传反面身份证/护照首页',
        'text564': '请上传地址证明',
        'text565': '请填写发放地址证明的政府机构',
        'text566': '请选择地址证明的发放日期',
        'text567': '持卡人姓名',
        'text568': '联名卡余额',
        'text569': '银联联名卡',
        'text570': '审核中',
        'text571': '审核通过',
        'text572': '审核失败',
        'text573': '证件签发国家',
        'text574': '请选择国家码',
        'text575': '请选择证件签发国家',
        'text576': '地址证明类别',
        'text577': '上传文件的语言',
        'text578': '请选择身份证/护照语言',
        'text579': '公司名称',
        'text580': '充值记录',
        'text581': '申请状态',
        'text582': '卡号（显示最后4位数）',
        'text583': '批准',
        'text584': '拒绝',
        'text585': '通过',
        'text586': '待定',
        'text587': '审核中',
        'text588': '活跃',
        'text589': '暂停',
        'text590': '您已批准卡的申请',
        'text591': '我们将会在三个工作日内审核联名卡的申请',
        'text592': '公司审核链接申请状态',
        'text593': '联名卡余额',
        'text594': '拒绝申请',
        'text595': '您确认要拒绝此联名卡申请？',
        'text596': '请提供拒绝理由',
        'text597': '拒绝',
        'text598': '请填写拒绝理由',
        'text599': '请确保你的KYC状态审核通过',
        'text600': '复制链接',
        'text601': '信用卡账单',
        'text602': '水电费账单',
        'text603': '银行对帐单',
        'text604': '银行信函',
        'text605': '英语',
        'text606': '西班牙语',
        'text607': '法语',
        'text608': '阿拉伯语',
        'text609': '华语',
        'text610': '日本语',
        'text611': '俄语',
        'text612': '葡萄牙语',
        'text613': '德语',
        'text614': '意大利语',
        'text615': '印度语',
        'text616': '其他',
        'text617': '证件签发国家',
        'text618': '住址证明 (正面）',
        'text619': '住址证明（背面，可选择上传）',
        'text620': '备注',
        'text621': '请选择地址语言证明',
        'text622': "搜索",
        'text623': "比如：持联名卡者姓名或联名卡号的最后4位数",
        'text624': "所有的状况",
        'text625': "激活",
        'text626': "充值",
        'text627': "激活此卡",
        'text628': "激活此卡，请输入以下的",
        'text629': "联名卡上的16位卡号",
        'text630': "卡ID,联名卡背面",
        'text631': "激活成功",
        'text632': "您已经成功激活此联名卡，谢谢。",
        'text633': "联名卡充值手续费",
        'text634': "联名卡的年费",
        'text635': "最低充值数额",
        'text636': "最高充值数额",
        'text637': "充值您的联名卡",
        'text638': "请确保您的账户钱包中有足够的余额。",
        'text639': "充值成功",
        'text640': "您已经成功充值美金",
        'text640_r': "到您的联名卡上",
        'text641': "充值失败",
        'text642': "程序上出现问题。请稍后再试。",
        'text643': "重试",
        'text644': "联名卡激活费",
        'text645': "手续费",
        'text646': "日期与时间",
        'text647': "来自",
        'text648': "充值数额（美金）",
        'text649': "失败",
        'text650': "最低数额是",
        'text651': "最高数额是",
        'text652': "现有的余额",
        'text653': "充值数额超出您当天最高充值限额",
        'text654': "请减少充值余额以便能继续",
        'text655': "您账号没有足够的",
        'text655_2': "余额。请充值您的银行账号或选择另一个币种",
        'text656': "充值我的账号",
        'text657': "您会获取",
        'text658': "联名卡号",
        'text659': "联名卡最高限額",
        'text660': "请输入16位卡号",
        'text661': "请输入身份证号",
        'text662': "转入的数量太少",
        'text663': "转入的数量小于最小数量",
        'text664': "转入的数量大于最大数量",
        'text665': "类型",
        'text666': "充值",
        'text667': "卡费",
        'text668': "激活卡的费用",
        'text669': "手续费",
        'text670': "补卡",
        'text671': "以上费用均以美元计算",
        'text672': '用户名格式为 大小写英文字母 数字 下划线',

        // BETH
        'text673_ok': '成功刷新卡余额',
        'text673': "与您的账号配对验证器",
        'text674': "扫描二维码",
        'text675': "请使用验证器扫描或拷贝密钥进行设置，并在下方输入所生成的6位验证码。",
        'text676': "请输入6位验证码以便登录（已配对的验证器）",
        'text677': "6位验证码",
        'text678': "请输入您已验证的电子邮箱。系统会发送指示邮件给您。",
        'text679': "（最少8个字符，包含至少一个大写字母、一个小写字母、一个数字和一个特殊字符）",
        'text680': "密码已更新",
        'text681': "您已成功更新您的密码。请使用最新的密码来登录。",
        'text682': "登录",
        'text683': "性别",
        'text684': "请输入验证器的6位数验证码",
        'text685': "成功激活联名卡",
        'text686': "您尾号",
        'text686_r': " 的联名卡已成功激活。",
        'text687': "管理联名卡",
        'text688': "我的卡",
        'text689': "简介",
        'text690': "有效期至",
        'text691': "CVV",
        'text692': "激活此联名卡",
        'text693': "设置2级认证",
        'text694': "资料",
        'text695': "更改地址",
        'text696': "新地址",
        'text697': "资料审核需要三个工作日。系统将会发送邮件通知审核结果。",
        'bt1': '由新技银行提供支持',
        'bt2': '申请新卡',
        'bt3': '* 您的数字钱包只能存入以下币种。如果您不小心存入不是以下的币种，请尽快联络客服 support@bethfinance.com',
        'bt4': '',
        'bt5': '',
        'bt6': '',
        'bt7': '',
        'bt8': '',
        'bt9': '',
        'bt10': '',

        'btext674': '存入的法定币将兑换为USDC。USDC余额将在USDC钱包显示。',
        'btext675': '存入法定币',
        'btext676': '转账资料',
        'btext677': '我们已经收到您的转账要求信息',
        'btext678': '您的客户经理会盡快的和您联系',
        'btext679': '其他货币',
        'btext680': '银行',
        'btext681': '汇款来自哪个国家',
        'btext682': '货币',
        'btext683': '选择货币',
        'btext684': '请填写数额',
        'btext685': '从那个银行汇款',
        'btext686': '从那个国家汇款',
        'btext687': '法定币存入',
        'btext688': '提币',
        'btext689': '转出到银行卡',
        'btext690': '扣除年费',
        'btext691': '扣除卡费',
        'btext692': '扣除激活费',
        'btext693': '退回年费',
        'btext694': '退回卡费',
        'btext695': '转换费用(USDT兑换USD)',
        'btext696': '转换费用(USDC兑换USD)',

        'text698': '护照 (Passport)',
        'text699': '身份证 (National ID)',
        'text700': '请选择证件类型',
        'text701': '到账类型',
        'text702': '到账数量',
        'text703': '注：法定币兑换USDC的兑换费用将会适用。',
        'text704': '注：最低账号激活数额为 1,000 USDT /USDC 。',
        'text705': '重置联名卡密码',
        'text706': '输入新的密码',
        'text707': '您将重置您联名卡密码。 请确保这4位数的密码安全的保留。为了安全起见，请不要透露给任何人。',
        'text708': '确认新的密码',
        'text709': '',
        'text710': '描述或供应商',
        'text711': '交易总额',
        'text712': '交易 ID',
        'text713': '本人声明，本次交易的资金来源：',
        'text714': '财产出售',
        'text715': '业务收益',
        'text716': '经营利润',
        'text717': '贸易',
        'text718': '其他',
        'text719': '服务费',
        'text720': 'KYC 通过',
        'text721': '尊敬的客户们，',
        'text722': '谢谢您对本行存款服务的兴趣。',
        'text723': '',
        'text724': '在本行您能存入美金，人民币，英镑，澳元，新币，港币将会在系统上USDT/USDC显示余额。',
        'text725': '为了方便客户们，本行与PAYBRIDGE强强联手增加了47个不同国家的法定币存入服务。您只需要在PAYBRIDGE做个简单的实名认证。',
        'text726': '',
        'text727': '当您成功在PAYBRIDGE兑换您的',
        'text728': '成USDT，您的USDT将会存入您的新技数字钱包里。您能在您的新技网上银行看见余额。',
        'text729': '以下简约的说明：',
        'text730': '本行 -> PAYBRIDGE -> PAYBRIDGE实名验证 -> 法定币兑换USDT(TRC20) -> USDT自动存入您的新技数字钱包',
        'text731': '页面将会跳转到PAYBRIDGE官网。',
        'text732': '* 每一笔数字资产转让需要缴 ',
        'text733': ' 手续费和 ',
        'text734': '纳燃气费',
        'text735': '备注',
        'text736': '* 您的数字钱包只能存入以下币种。如果您不小心存入不是以下的币种，请尽快联络客服 support@finexteasternbank.com',
        'text737': '转账固定费',
        'text738': '转账',
        'text738_2': ' 费用',
        'text739': '转帐费用',
        'text740': '转帐固定费用',
        'text741': '扣除',
        'text742': '充值金额 ',
        'text743': '充值金额USDT ',
        'text744': '系统收取金额 ',
        'text745': '总扣除额为USDT',
        'text746': '我的账户',
        'text747': '法定币存入',
        'text748': '数字资产存入',
        'text749': '法定币汇款与付费',
        'text750': '数字资产汇款与付费',
        'text751': '交易明细',
        'text767': '卡片后4位',
        'text768': '交易证明号',
        'text769': '提款',
        'text770': '汇款',
        'text771': '余额（透支)',
        'text772': '汇款与付费（收款方）',
        'text773': '汇款方账号姓名',
        'text774': '请填写汇款方账号姓名',
        'text775': '绿色-法定币交易',
        'text776': '白色-数字资产交易',
        'text777': '收益',
        'text778': '转介',
        'text779': '银行流水',
        'text780': '银行流水（ 近6个月 ）',
        'text781': '流水',
        'text782': '提供的所有文件必须为英文或附有经过认证的翻译。',
        'text783': '交易通知',
        'text784': '',
        'text785': '',
        'text786': '',
        'text787': '',
        'text788': '',
        'text789': '',
        'text790': '',
        'text791': '备注',
        'text792': '最低账号激活数额为1,000 USD 。',
        'text793': '到账数量',

    },

    // 银行卡预约
    bank_card:{
        card_reservation        :"预订合约模块",
        contract_management     :"卡片预购管理",
        Card_management         :"卡片管理",
        KYC_info                :"KYC 细节",
        Personal_Details        :"个人资料",
        Mobile_Phone            :"手机号码",
        Gender                  :"性别",
        Male                    :"男性 (Male)",
        Female                  :"女性 (Female)",
        Username_Beth           :"用户名(为BETH登录）",
        Name_appear             :"联名卡显示的名字",
        Proof_Identity          :"身份证明",
        Passport_National       :"护照/国民身份证号码",
        Select_language         :"请选择证件语言",
        Address_Proof           :"请上传住址证明 (正面)",
        Address_Proof_Back      :"请上传住址证明 (背面，非必填)",
        Address_Type            :"住址证明类别",
        Address_Language        :"请选择文档语言",
        Address_Issued_By       :"地址发布者",
        Address_Issued_Date     :"地址签发日期",
        reservation_management  :"预购-卡管理",
        Please_enter_name       :"输入卡上的姓名",
        Please_enter_email      :"输入电子邮件",
        state                   :"状态",
        uncommitted             :"未提交",
        approved                :"通过",
        rejected                :"拒绝",
        active                  :"已激活",
        blocked                 :"冻结",
        kyc_approved            :"KYC 通过",
        card_level              :"卡级别",
        Premier                 :"Premier",
        Prestige                :"Prestige",
        Card_class              :"卡类型",
        VISA                    :"Visa",
        Mastercard              :"Mastercard",
        UnionPay                :"UnionPay",
        card_number             :"卡号",
        There                   :"总数",
        are_records             :"记录数量",
        application_date        :"查询日期",
        Card_name               :"联名卡显示的名字",
        email                   :"电邮",
        Corporate_Clent         :"企业客户",
        Card_Fee                :"卡费",
        unpaid                  :"未缴费",
        paid                    :"已缴费",
        Annual_Membership       :"年度会员资格",
        branded_card_level      :"卡牌等级",
        branded_card_category   :"卡的种类",
        Date_lssuse             :"签发日期",
        Date_Expiry             :"到期日期",
        Corporate_Client_Action :"企业客户行动",
        Bind                    :"绑定",
        unbind                  :"未绑定",
        binding_card            :"绑定卡",
        create_time             :"订单日期",
        order_id                :"订单ID",
        amount_num              :"订单数量",
        status_1                :"待定",
        status_2                :"已批准",
        status_3                :"已拒绝",
        status_4                :"部分分配",
        status_5                :"已分配",
        status_remark           :"状态备注",
        operate                 :"操作",
        select                  :"选择",
        allocated_cards         :"已分配的卡",
        kit_number              :"Kit号",
        is_unbind               :"确定解绑卡？",
        confirm                 :"确认",
        bind_success            :"绑定成功",
        unbind_success          :"取消成功",
        card_issuing_record     :"卡预购-合同管理-合同明细-卡记录",
        Date_issue              :"发行日期",
        check_order             :"预订模块-合同管理-查看订单",
        con_management          :"卡预购管理 - 合同",
        Start_date              :"开始日期/结束日期",
        Contract_ID             :"合同ID",
        total_amount            :"合同数量",
        payment_amount          :"已缴费数量",
        left_amount             :"合约可订数量",
        order_amount            :"订购数量",
        place_order             :"下单",
        View_the_contract       :"查看合同",
        check_an_order          :"查看订单",
        order_num               :"订购数量",
        Minimum_quantity        :"每批订单的最低下单数量",
        Contract_term_month     :"合同期",
        contract_quantity       :"合同数量",
        Number_reservation      :"预购数量",
        zhang                   :"张",
        date_of_payment         :"付款日期",
        di                      :"数量",
        Period_quantity         :"抵押数量",
        Minimum_order_quantity  :"每批订单的最低下单数量",
        available_quantity      :"可发数量",
        Current_number_audited  :"当前待定的 KYC",
        Current_number_issued   :"当前待发的",
        Order_success           :"下单成功",
        Allocated_quantity      :"分配数量",
        unallocated_quantity    :"未分配数量",
        Ass_management          :"用户权限管理",
        KYC_Processing          :"KYC 处理中",
        Printing                :"打印中",
        Card_Binded             :"已用的卡",
        Activated               :"已激活",
        freeze                  :"冻结卡",
        Whether_freeze_account  :"确定冻结卡？",
        Freezing_success        :"冻结卡成功",
        Total_Order             :"总订单数量",
        Card_Unbind             :"可用卡",
        KYC_Pending             :"用户等待 KYC",
        KYC_Approved_binded     :"用户待办卡",
        username_email          :"输入用户访问用户名/电子邮件,",
        Subaccount_status       :"帐户状态",
        start                   :"活跃",
        forbidden               :"未激活",
        in_all                  :"总数",
        Bar_data                :"记录数量",
        User_name_subaccount    :"子账号用户名",
        Subaccount_mailbox      :"子账号用户电邮",
        operation               :"动作",
        permission_view         :"查看访问权限",
        Ass_Acc_View            :"“用户权限模块-查看访问权限",
        Remarks                 :"备注",
        group_name              :"用户权限群",
        describe                :"描述",
        thaw                    :"解冻",
        Operation_Status        :"运营状态",
        Successful_thawing      :"解冻成功",
        Card_Binded2            :"卡绑定",
        FEB_Debit_Cards         :"FEB卡",
        FEB_VISA_Premier        :"FEB VISA Premier",
        FEB_VISA_Premier_m      :"FEB VISA Premier (金属)",
        View_Plan               :"查看计划",
        Directors_Staffs        :"董事、员工和同事有资格申请此卡。",
        Client_Block            :"用户冻结",
        Admin_Block             :"后台冻结",
        User_Block              :"用户冻结",
        Enter_Code              :"输入验证码",
        Please_enter_OTP        :"请输入OTP验证码并点击Verify完成验证",
        Verify                  :"验证",
        Create_Password         :"输入密码",
        enter_Password          :"再次输入密码",
        My_mailing_address      :"我的邮寄地址与上述住址相同。",
        Please_provide          :"请提供您希望我们将卡安全送达的邮寄地址。",
        For_ID_Card             :"对于没有签发日期的身份证，请填入自18岁起的日期",
        ID_Card_without         :"对于未过期的身份证，自出生之日起至少加55年。",
        Important_Please        :"重要提示：请上传您身份证明文件的英文翻译版本。",
        If_you_are              :"如果您提交的是非英文文件，请提供英文翻译。清晰标注原始文件上的所有重要信息，并上传翻译版本。如有需要，请使用可靠的翻译服务。",
        Image_File_Type         :"*图片文件类型：jpeg、png、pdf。",
        Image_Size_Limit        :"*图片大小限制：每个文件最多5MB。",
        Allow_up_to             :"*最多允许上传1个文件。",
        Please_upload_English   :"重要提示：请上传您住址证明文件的英文翻译版本。",
        label_in_English        :"(英文标识)",
        Please_ensure_that      :"请确保您的住址证明上显示了您的姓名、地址和日期。",
        Issuing_authority       :"发行机构名称，如公用事业公司或银行的名称。",
        Must_be_dated           :"住址证明的开具日期必须在提交日期之前的三个月 (90天) 内。",
        Notes                   :"重要须知：",
        Ensure_documents        :"确保您提交的文件与申请表中提供的信息相符。",
        Submit_complete         :"提交完整的身份证明文件，不要阻挡或裁剪任何详细信息。",
        Take_clear              :"拍摄清晰、聚焦的图像，避免模糊重要信息。",
        When_capturing          :"在拍摄文件图像时，请确保相机与文件平行，避免扭曲图像。",
        Do_not_add              :"不要添加水印或任何标明使用目的的文字。",
        If_your_full            :"如果您的全名中含有中间名或第二个姓氏，您只需提供名字和姓氏即可进行KYC提交。",
        Please_email_verif      :"请完成邮箱验证",
        enter_PIN               :"请输入密码",
        enter_pwd_verif         :"请输入密码验证",
        pwd_not_match           :"两次密码不一致",
        Please_Gender           :"请选择Gender",
        mailing_address         :"邮寄地址",
        mail_country            :"邮寄国家",
        mail_city               :"邮寄城市",
        mail_state              :"邮寄地区",
        mail_postal_code        :"邮寄编码",
        upload_file_first       :"请先上传文件",
        Verify_name_first       :"请先验证用户名",
        verify_email_first      :"请先验证邮箱",
        Email_verification      :"邮箱验证通过",
        name_succeeded          :"用户名验证通过",
        Cancelled               :"取消",
        Driver_License          :"驾照 (Driver License)",
        Insurance_Policy        :"保险单据 (Insurance Policy)",
        Post_Balance            :"邮局余额证明 (Post Office Balance Certificate)",
        Other_Government        :"其他政府签发文件 (Other Government Issued Document)",
        card_cost_status        :"卡费状态",
        card_cost_status0       :"未缴纳",
        card_cost_status1       :"已缴纳",
        card_cost               :"卡费",
        Corporate_Clent_Prefix  :"公司简称",
        The_company             :"公司简称是打印卡流程中的必填项，请前去设置。",
        Click_jump              :"点击跳转",
        KYC_Management          :"KYC管理",
        mailed                  :"邮寄",
        Card_anomaly            :"卡异常",
        Refuse_card             :"拒绝补卡",
        replacement_card        :"补卡中",
        Rep_card                :"申请补卡",
        Reissued_card           :"已补卡",
        Consolidating           :"整合中",
        Print_batch_number      :"打印批号",
        company_abbreviation    :"公司简称",
        delivery_type           :"邮寄方式",
        print_number            :"打印批号",
        op_status_time          :"运营状态更新日期",
        op_cause_type1          :"丢失失窃",
        op_cause_type2          :"损坏",
        op_cause_type3          :"用户损坏",
        op_cause_type4          :"工厂损坏",
        op_cause_type5          :"激活失败",
        op_cause_type6          :"设置PIN失败",
        op_cause_type7          :"派送问题",
        op_cause_type8          :"诈骗",
        op_cause_type9          :"邮寄未退回",
        op_cause_type10         :"邮寄退回",
        active_fail_reason      :"激活失败理由",
        mail_address            :"卡邮寄地址",
        View                    :"查看",
        Modify_status           :"修改运营状态",
        Please_op_status        :"请选择运营状态",
        Card_abnormal_cause     :"卡异常",
        Select_card_cause       :"请选择卡异常原因",
        Username                :"用户名",
        Role                    :"角色",
        Apply_For               :"申请为",
        Staff                   :"员工",
        kyc_id_status           :"身份验证状态",
        Under_Review            :"审核中",
        kyc_address_status      :"验证地址状态",
        KYC_Message             :"KYC备注",
        reject_reason1          :"数据问题",
        reject_reason2          :"状态问题",
        reject_reason3          :"用户kyc未通过",
        reject_reason4          :"分配卡失败",
        reject_reason5          :"激活失败",
        reject_reason6          :"设置PIN失败",
        Operator                :"操作人",
        No_more_than_5          :"英文大写字母不多于5位",
        mailed_s                :"邮寄",
        For_banking_login       :"用于网上银行登录",
        not_filed               :"未提交",
        annual_fee_status       :"年费状态",
        card_replace_fee        :"补卡费",
        card_price              :"卡成本",
        sale_name               :"关系经理",
        design_details          :"卡片材料与设计",
        design_category         :"设计类别",
        material                :"材料",
        material_color          :"材质颜色",
        font_color              :"字体颜色",
        feb_logo                :"FEB LOGO",
        merchant_logo           :"Client LOGO",
        card_picture            :"卡图像",
        Packing_arrangement     :"包装类型",
        packaging_type          :"包装类型",
        done_by                 :"完成者",
        cost_to_client          :"客户成本",
        stage                   :"送货",
        from_to                 :"从到",
        printing_type           :"打印类型",
        delivery_note           :"交货单",
        delivery_address        :"邮寄地址",
        contract                :"接触",
        mobile_no               :"手机号码",
        contract_id             :"合同ID",
        prepayment              :"预缴纳",
        returned                :"已退回",
        There_problem_image     :"你上传的图片格式有问题。请用其他图像格式再试一次。",
        Collaborative_Cards     :"合作卡",
        Pending_Rebind          :"待重新绑定",
        Upload_error            :"文件上传失败请换个网络刷新页面重试",
        card_username           :"卡用户名",
        top_up_fee              :"充值费",
        min_top_up              :"最低充值费",
        max_top_up              :"最高充值费",
        Full_Contract_Summary   :"合同汇总表",
        Contracted_Paid         :"合同数量 - 已付",
        Card_Qty_Order          :"可订购的卡量",
        Total_Cards_Ordered     :"已订购卡总量",
        Total_Cards_Allocated   :"已分配卡总量",
        Order_Summary_Page      :"订单摘要页面",
        Card_Qty_Allocation     :"当下等待分配的卡量",
        Card_Qty_Bind           :"当下可绑定的卡两",
        Cards_ordered_available :"当下可用的卡量",
        Total_Cards_Used        :"已消耗卡总量",
        Card_Qty_print          :"保留用于打印的卡",
        Card_Qty_pending_Bind   :"等待绑定的卡",
        Card_Qty_Activation     :"等待激活的卡",
        Total_Cards_Activated   :"卡片总激活量",
        Total_Cards_Bind        :"卡片总绑定两",
        Users                   :"用户",
        users_kyc_approved      :"用户KYC审及格过量",
        users_pending_kyc       :"当下等待KYC审核的用户",
        pending_consolidation   :"当下KYC以及各的用户",
        pending_payment         :"当下等待付卡/年费的用户",
        pending_users           :"待处理的用户",
        users_reserved_print    :"当下等待印刷的用户",
        printed_pending_bind    :"当下等待绑定的用户",
        awaiting_activation     :"当下等待激活卡的用户",
        with_card_activated     :"已激活卡的总用户量",
        with_card_bind          :"等待激活与已激活卡总用户量",
        card_array              :"Card Array",
        plus_price              :"卡成本",
        data_problem            :"数据问题",
        state_problem           :"状态问题",
        User_kyc_failed         :"用户kyc未通过",
        Allocation_card_failure :"分配卡失败",
        Activation_failure      :"激活失败",
        Failed_set_pin          :"设置pin失败",
        Webhook_notif           :"Webhook通知设置",
        After_the_setting       :"设置成功后,您将会收到状态变更的相关通知",
        Please_API_link         :"请填写API链接",
        KYC_status_change       :"KYC状态变更通知",
        status_noti             :"充值状态通知",
        Card_status_noti        :"卡运营状态通知",
        activation_success      :"卡激活成功通知",
        Cancelling              :"正在取消",
        Beth_API_Status         :"Beth/API 状态",
        CONTROLS                :"控制",
        Cards_List              :"卡列表",
        Card_mailing_address    :"卡邮寄地址",
        Mail_Address_Line       :"地址第一行",
        Mail_Address_Line2      :"地址第二行",
        Mail_City               :"城市",
        Mail_State              :"省/州属",
        Mail_Country            :"居住国家",
        Mail_Postal_Code        :"邮政编码",
        Security_Code           :"确认码",
        Sales_Type              :"销售类型",
        General                 :"普通",
        QR_Code                 :"二维码",
        verify_passed           :"验证通过",
        v_kit_number_code       :"请先完成Kit Code 和 Activation Code 的验证。如有疑问，请联系客服人员。",
        URL                     :"链接",
        operating_time          :"操作时间",
        r_w_get                 :"Recipient will get",
        Conversion_fee          :"Conversion fee of ",
        Flat_Fee                :"Flat Fee",
        Amount_Deducted         :"Amount Deducted",




        

    },

    beth_text:{
        Residential_address         :"居住地址",
        Mail_Address_Line           :"地址第一行",
        Mail_Address_Line2          :"地址第二行",
        Mail_City                   :"城市",
        Mail_State                  :"状态",
        Mail_Country                :"国家",
        Mail_Postal_Code            :"邮政编码",
        Block_Card                  :"冻结卡",
        Replace_Card                :"补卡",
        renew                       :"续年费",
        Expired                     :"已过期",
        Confirmed_freezing          :"确认冻结卡吗?冻结后您将无法使用该卡,您可以随时解冻。",
        Confirmed_thawing           :"确认解冻卡吗?解冻后您将恢复该卡的使用。",
        Reason_replacement          :"请选择补卡原因",
        Card_loss                   :"卡丢失",
        Confirm_to_freeze           :"确认冻结该卡并支付补卡费{fee} USDC/T？此操作不可撤销。",
        address_accurate            :"请确认您的邮寄地址准确无误,以便于接收新卡。",
        Card_damage                 :"卡损坏",
        Not_sure_card               :"不确定卡是否已丢失?请先",
        Temporarily_block_it        :"自行冻结卡",
        Temporarily_block_it_btm    :"阻止新的交易。",
        card_recovered              :"若寻回卡,可随时自行解冻并恢复使用。",
        Whether_damaged             :"不确定卡是否损坏?请先与客服联系进行查询。",
        Mailing_address_accurate    :"请确认您的邮寄地址准确无误，以便于接收新卡。",
        card_administrator          :"您的卡已被管理员冻结,无法进行该操作。",
        password_cannot_changed     :"当前状态不支持修改密码。",
        Freezing_success            :"冻结成功",
        applied_replacement_card    :"已申请补卡，无法进行解冻，如有疑问请联系客服。",
        card_frozen_administrator   :"您的卡已被管理员冻结,如有疑问请联系客服。",
        Card_replacement_success    :"申请补卡成功",
        msg_notice                  :"消息通知",
        system_notice               :"系统公告",
        Clear_unread                :"全部标为已读",
        Clear_successfully          :"清除成功",
        Automatic_annual_renewal    :"开通自动续年费",
        Ticked_FEB                  :"您的下一个会员年费将自动从您所属公司的新技账户中扣除，金额为 {payment_amount} USDC/T（合计{payment_month}个月），收费日期为{payment_date}。",
        Ticked_Beth                 :"您的下一个会员年费将自动从您的Beth钱包余额中扣除，金额为 {payment_amount} USDC/T（合计{payment_month}个月），收费日期为{payment_date}。",
        Please_make                 :"请在{payment_date}之前支付{payment_amount} USDC/T（合计{payment_month}个月），以避免您的卡被取消。",
        Current_Annual              :"当前会员年费：{current_amount} USDC/T",
        Card_No                     :"卡号",
        Expiry_Date                 :"有效日期",
        Term_Start_Date             :"开始日期",
        Term_End_Date               :"结束日期",
        Auto_Renewal_Date           :"收费日期",
        Payment_Months              :"合计月数",
        Membership_Fee_Due          :"扣费金额",
        Payment_Status              :"付费状态",
        pay                         :"付款",
        pay1                        :"已付",
        pay_another                 :"待付",
        overdue                     :"逾期",
        unpaid                      :"未付",
        Payment_Date                :"付费日期",
        need_to_pay                 :"本次需要支付 {payment_amount} USDC/T，是否支付？",
        successfully_set            :"设置成功",
        payment_success             :"支付成功",
        renewal_first               :"请先完成之前的续费",
        Free_annual_fee             :"免年费",
        feb_account                 :"您所属的FEB账户需要为这笔交易支付{payment_amount}美元C/T。确认继续？",
        Account_Balance             :"账户余额",
        Delete_Read                 :"删除已读",
        Card_Name                   :"卡名",
        Cardholder_Agreement        :"持卡人协议",
        read_agree                  :"接受",
        Unticked_Please             :"请在年月日之前支付{payment_amount} USDC/T（{payment_month}个月），以避免您的卡被取消。",
        Your_been                   :"您的卡已被指示不再续期，并将于{annual_fee_end_time}到期，如有疑问请联系客服。",
        text34: '账户名称',
    },
    
    pdf: {
        'text1': '联名卡',
        'text2': '账户结单',
        'text3': '联名卡汇总',
        'text4': '结单日期',
        'text5': '最高储值限额',
        'text6': '承上结余',
        'text7': '充值',
        'text8': '提款',
        'text9': '费用',
        'text10': '联名卡结余',
        'text11': '下一个续订周期',
        'text12': '页数',
        'text13': '请登录 www.bethfiannce.com 进行账户查询或使用本行的服务',
        'text14': '联名卡',
        'text15': '交易日期',
        'text16': '交易类别',
        'text17': '金额',
        'text18': '结余',
        'text19': '总额',
        'text20': '上述结余不反映交易过帐时您账户上可能未结清的任何待处理提款或存入资金。如可用余额不足而您选择进行交易，则可能依然记账手续费。',
        'text21': '重要信息',
        'text22': '保护自己免受欺诈',
        'text23': '切勿向任何人共享您的登录信息（如用户及登录密码）以及联名卡密码。',
        'text24': '立即重置您的联名卡密码',
        'text25': '忘记您的联名卡密码 ？您可以登录您的Beth账户进行联名卡密码重置。',
        'text26': '联名卡信息表',
        'text27': '此信息仅作简短的消费者指南。有关详细信息，请阅读相应的持卡人协议。',
        'text28': '最高储值限额',
        'text29': '您可以随时向您的联名卡帐户添加资金，但不得超过最高储值限额。',
        'text30': '进行外币交易',
        'text31': '如果您使用外币进行交易，支付卡网络如VISA，会将其转换为美元金额。支付卡网络将使用其货币转换程序。结算日期所使用的汇率可能与账户结单上显示交易日期的有效汇率有所不同。我们可能会调整汇率或收取额外的货币兑换费。',
        'text32': '交易费用',
        'text33': '充值费',
        'text34': '销售点/网购费',
        'text35': '取款机提现',
        'text36': '取款机余额查询',
        'text37': '交易参数',
        'text38': '最高储值限额',
        'text39': '根据类别',
        'text40': '单卡最低储值限额',
        'text41': '单次最高充值限额',
        'text42': '每日最多交易次数',
        'text43': '每月最多交易次数',
        'text44': '单笔交易最高交易额',
        'text45': '每日最高交易额',
        'text46': '每月最高交易额',
        'text47': '每日最多提现次数',
        'text48': '每月最多提现次数',
        'text49': '每日最高提现额',
        'text50': '每月最高提现额',
        'text51': '服务费',
        'text52': '卡费',
        'text53': '激活费',
        'text54': '换卡费',
        'text55': '月费',
        'text56': '会员年费',
        'text57': '如果本账户结单中的任何信息与持卡人协议不一致，以持卡人协议为准。',
        'text58': '',
        'text59': '',

        text77: "银行服务附加联名卡注册费",
    },
    v_life:{
        visionLife_id   :"VisionLife账户",
        verify_v_id     :"格式错误，字母、数字和特殊字符，5到20位组合；",
        id_verify_passed:"VisionLife ID 验证通过",
        please_v_id     :"请填写VisionLife账户",
        read_content    :"请向下滚动并接受协议以继续",
        Privacy_Data    :"隐私与数据使用声明",
        We_your_privacy :"我们珍视您的隐私，并承诺保护您的个人信息。您在此申请中提供的数据将仅用于账户处理和身份验证。除非受到法律要求的强制，我们不会将您的数据透露给第三方。",
        Card_Name       :"卡名",
    },
    str_status:{
        str_status_1:"未提交",
        str_status_2:"审核中",
        str_status_3:"成功",
        str_status_4:"失败",
    },
    top_up_dlg:{
        Max_per     :"单笔充值最大值:",
        Current_Cap :"当前充值上限:",
        Source_fund :"资金来源",
        E_Income    :"就业收入",
        I_Income    :"投资收益",
        B_Income    :"业务收入",
        Savings     :"储蓄",
        Loans       :"贷款",
        Sales_I     :"投资出售",
        Gifts       :"礼物",
        Others      :"其他",
        I_confirm   :"我确认这些资金来自如上所述的合法来源，并承诺在未来如有需要将提供必要的资金来源证明。",
        Please_check:"请先勾选以上内容以提交申请",
        t_status1   :"成功",
        t_status2   :"取消",
        t_status3   :"处理中",
        t_status4   :"重试",
        t_status5   :"退还",
        P_may       :"该充值可能需要3-5个工作日的处理时间。",

    },
    beth_text2:{
        Residential_address         :"居住地址",
        Mail_Address_Line           :"地址第一行",
        Mail_Address_Line2          :"地址第二行",
        Mail_City                   :"城市",
        Mail_State                  :"状态",
        Mail_Country                :"国家",
        Mail_Postal_Code            :"邮政编码",
        Block_Card                  :"冻结卡",
        Replace_Card                :"补卡",
        renew                       :"续年费",
        Expired                     :"已过期",
        Confirmed_freezing          :"确认冻结卡吗?冻结后您将无法使用该卡,您可以随时解冻。",
        Confirmed_thawing           :"确认解冻卡吗?解冻后您将恢复该卡的使用。",
        Reason_replacement          :"请选择补卡原因",
        Card_loss                   :"卡丢失",
        Confirm_to_freeze           :"确认冻结该卡并支付补卡费{fee} USDC/T？此操作不可撤销。",
        address_accurate            :"请确认您的邮寄地址准确无误,以便于接收新卡。",
        Card_damage                 :"卡损坏",
        Not_sure_card               :"不确定卡是否已丢失?请先",
        Temporarily_block_it        :"自行冻结卡",
        Temporarily_block_it_btm    :"阻止新的交易。",
        card_recovered              :"若寻回卡,可随时自行解冻并恢复使用。",
        Whether_damaged             :"不确定卡是否损坏?请先与客服联系进行查询。",
        Mailing_address_accurate    :"请确认您的邮寄地址准确无误，以便于接收新卡。",
        card_administrator          :"您的卡已被管理员冻结,无法进行该操作。",
        password_cannot_changed     :"当前状态不支持修改密码。",
        Freezing_success            :"冻结成功",
        applied_replacement_card    :"已申请补卡，无法进行解冻，如有疑问请联系客服。",
        card_frozen_administrator   :"您的卡已被管理员冻结,如有疑问请联系客服。",
        Card_replacement_success    :"申请补卡成功",
        msg_notice                  :"消息通知",
        system_notice               :"系统公告",
        Clear_unread                :"全部标为已读",
        Clear_successfully          :"清除成功",
        Automatic_annual_renewal    :"开通自动续年费",
        Ticked_FEB                  :"您的下一个会员年费将自动从您所属公司的新技账户中扣除，金额为 {payment_amount} USDC/T（合计{payment_month}个月），收费日期为{payment_date}。",
        Ticked_Beth                 :"您的下一个会员年费将自动从您的Beth钱包余额中扣除，金额为 {payment_amount} USDC/T（合计{payment_month}个月），收费日期为{payment_date}。",
        Please_make                 :"请在{payment_date}之前支付{payment_amount} USDC/T（合计{payment_month}个月），以避免您的卡被取消。",
        Current_Annual              :"当前会员年费：{current_amount} USDC/T",
        Card_No                     :"卡号",
        Expiry_Date                 :"有效日期",
        Term_Start_Date             :"开始日期",
        Term_End_Date               :"结束日期",
        Auto_Renewal_Date           :"收费日期",
        Payment_Months              :"合计月数",
        Membership_Fee_Due          :"扣费金额",
        Payment_Status              :"付费状态",
        pay                         :"付款",
        pay1                        :"已付",
        pay_another                 :"待付",
        overdue                     :"逾期",
        unpaid                      :"未付",
        Payment_Date                :"付费日期",
        need_to_pay                 :"本次需要支付 {payment_amount} USDC/T，是否支付？",
        successfully_set            :"设置成功",
        payment_success             :"支付成功",
        renewal_first               :"请先完成之前的续费",
        Free_annual_fee             :"免年费",
        feb_account                 :"您所属的FEB账户需要为这笔交易支付{payment_amount}美元C/T。确认继续？",
        Account_Balance             :"账户余额",
        Delete_Read                 :"删除已读",
        Card_Name                   :"卡名",
        Cardholder_Agreement        :"持卡人协议",
        read_agree                  :"接受",
        Renewal_Status              :"续费状态",
        free_charge                 :"免费",
        due_soon                    :"即将到期",
        Deduction_Mode              :"付款模式",
        auto                        :"自动",
        automatically               :"确认自动",
        stop                        :"停止",
        Modify_Mode                 :"修改模式",
        Edit_Remarks                :"编辑备注",
        Pending_status              :"待处理",
        Discontinued                :"终止",
        User                        :"用户",
        yearly_expire_date          :"每年到期日期",

    },
    new1_txt:{
        Unsettled           :"未结算",
        Settled             :"已结算",
        CR                  :"存入",
        DR                  :"提取",
    },
    new3_txt:{
        P_Resubmission      :"待用户重新提交",
        KYC_Rejected        :"KYC被拒绝",
        ekyc_link           :"eKYC链接",
        current_PIN         :"当前4位PIN码",
    }

}